/**
 * Upload d'images vers Cloudinary
 * Retourne uniquement l'URL, pas de base64
 */

const CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/dbkn2kqgn/image/upload';
const UPLOAD_PRESET = 'clickorico_products';

/**
 * Upload un fichier unique vers Cloudinary
 * @param {File} file - Le fichier à uploader
 * @param {string} folder - Dossier Cloudinary (optionnel)
 * @returns {Promise<string>} - URL sécurisée de l'image
 */
export const uploadImageToCloudinary = async (file, folder = 'products') => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', folder);

    const response = await fetch(CLOUDINARY_UPLOAD_URL, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Erreur upload Cloudinary: ${response.status}`);
    }

    const data = await response.json();
    return data.secure_url;
  } catch (error) {
    console.error('Erreur upload Cloudinary:', error);
    throw error;
  }
};

/**
 * Upload plusieurs fichiers vers Cloudinary
 * @param {File[]} files - Tableau de fichiers
 * @param {string} folder - Dossier Cloudinary (optionnel)
 * @returns {Promise<string[]>} - Tableau d'URLs sécurisées
 */
export const uploadMultipleImagesToCloudinary = async (files, folder = 'products') => {
  try {
    const uploadPromises = files.map(file => uploadImageToCloudinary(file, folder));
    const urls = await Promise.all(uploadPromises);
    return urls;
  } catch (error) {
    console.error('Erreur upload multiple Cloudinary:', error);
    throw error;
  }
};


